import JobInfoDTO from '@src/adapters/dto/job/JobInfoDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

interface Result {
  job: JobInfoDTO;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/job/info',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
  useGCKey: true,
};

export const useFindJobInformationLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindJobInformationLazy;
